<script>
  import { onDestroy } from "svelte";
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import { progressStore, filterStateStore } from "./stores.js";
  import { pluralTitle } from "./helpers.js";

  export let filterVersion;

  $: getClassName = () => {
    return `progress-bar ${$progressStore.type}`;
  };

  let barValue = tweened(0, {
    duration: 1000,
    easing: cubicOut
  });

  function animateBar() {
    if ($progressStore) {
      barValue.set($progressStore.percent);
    }
  }

  const unsubProgressStore = progressStore.subscribe(val => {
    if (!filterVersion) {
      animateBar();
    }
  });

  const unsubFilterStateStore = filterStateStore.subscribe(val => {
    if (val.active) {
      window.setTimeout(() => {
        animateBar();
      }, 300);
    }
  });

  onDestroy(() => {
    unsubProgressStore();
    unsubFilterStateStore();
  });
</script>

<style>
  h5 {
    font-size: 0.75rem;
    margin: 0;
  }

  .progress {
    background: #eee;
    border-radius: 12px;
    height: 7px;
    margin: 4px 0;
    overflow: hidden;
  }

  .progress-bar {
    border-radius: 12px;
    height: 7px;
    width: 0%;
  }

  .kanji {
    background: var(--pink);
  }

  .vocabulary {
    background: var(--purple);
  }

  .radical {
    background: var(--blue);
  }

  small {
    font-size: 0.65rem;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
  }
</style>

{#if $progressStore}
  <div class="wrapper">
    <h5>Level {$progressStore.level}</h5>
    <div class="progress">
      <div class={getClassName()} style={`width: ${$barValue}%`} />
    </div>
    <small>
      {$progressStore.completed} of {$progressStore.total}
      {pluralTitle($progressStore.type)} studied
    </small>
  </div>
{/if}
